
import { throttle } from 'underscore';

let $burger = $('.js-burger-scroll');

function init() {
	if($($burger).length) {
		window.addEventListener("scroll", throttle(scrollHandler, 150), { passive: true });
		scrollHandler();
	}
}

function scrollHandler(event) {
	let top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
	
	if (top > 50) {
		$burger.addClass('burger--with-background');
	} else {
		$burger.removeClass('burger--with-background');
	}
}

export default {
	init
}